import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { BottomPanel } from '@euler/components/BottomPanel';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { BiDashboardFilters } from '@euler/model/bi/dashboard';
import { BiPalette } from '@euler/model/bi/viz';
import { memo } from 'react';
import { ScrollView, View } from 'react-native';
import { CardEditorForm } from './CardEditorForm';
import { EditorFooter } from './EditorFooter';
import { BiEditorTarget } from './functions/biEditorState';
import { BiCardSave, useBiCardEditor } from './functions/useBiCardEditor';

/** The card form in a sheet: on the dashboard, and on a phone's card page. */
export const CardEditorPanel = memo(
  ({
    target,
    filters,
    palette,
    onSave,
    onClose,
  }: {
    /** Null while closed. */
    target: BiEditorTarget | null;
    /** What the card is viewed under; the preview runs under it. */
    filters: BiDashboardFilters;
    /** The dashboard's palette, which the card takes unless it sets one. */
    palette: BiPalette;
    /** A refusal keeps the form open and says why, in place. */
    onSave: BiCardSave;
    onClose: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    const editor = useBiCardEditor(target, onSave, filters);
    return (
      <BottomPanel visible={target !== null} onClose={onClose} tall>
        <View style={{ flex: 1 }}>
          <View style={{ paddingHorizontal: rpx(24), paddingTop: rpx(24) }}>
            <Typography.Text medium size={rpx(15)} color={aiColors.foreground}>
              {target?.kind === 'edit' ? '编辑图表' : '添加图表'}
            </Typography.Text>
          </View>
          <ScrollView
            style={{ flex: 1 }}
            contentContainerStyle={{ padding: rpx(24) }}
            keyboardShouldPersistTaps="handled"
          >
            <CardEditorForm editor={editor} palette={palette} withPreview />
          </ScrollView>
          <EditorFooter
            error={editor.error}
            saveTitle={target?.kind === 'edit' ? '保存' : '添加到看板'}
            busy={editor.busy}
            canSave={editor.canSave}
            onCancel={onClose}
            onSave={async () => {
              if (await editor.save()) onClose();
            }}
          />
        </View>
      </BottomPanel>
    );
  },
);
